import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createSchemeGiftItem,
  fetchAllSchemeGiftItems,
  updateSchemeGiftItem,
  fetchOneSchemeGiftItem,
  deleteSchemeGiftItem,
} from "services/schmitemaster";

// Fetch all scheme gift items with optional filtering
export const useAllSchemeGiftItems = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["schemeGiftItems", filters],
    queryFn: () => fetchAllSchemeGiftItems(filters),
    enabled,
  });
};

// Fetch single scheme gift item by ID
export const useOneSchemeGiftItem = (id, enabled = true) => {
  return useQuery({
    queryKey: ["schemeGiftItem", id],
    queryFn: () => fetchOneSchemeGiftItem(id),
    enabled: Boolean(id) && enabled,
  });
};

// Create new scheme gift item
export const useCreateSchemeGiftItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createSchemeGiftItem(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schemeGiftItems"] });
    },
  });
};

// Update existing scheme gift item
export const useUpdateSchemeGiftItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateSchemeGiftItem(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["schemeGiftItems"] });
      queryClient.invalidateQueries({ queryKey: ["schemeGiftItem", variables.id] });
    },
  });
};

// Delete scheme gift item
export const useDeleteSchemeGiftItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteSchemeGiftItem(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["schemeGiftItems"] });
      queryClient.invalidateQueries({ queryKey: ["schemeGiftItem", id] });
    },
  });
};
